export default __webpack_public_path__ + "static/media/SOM.0bdd11e3.svg";